import { render } from "./InvoiceEmail.vue?vue&type=template&id=5f929636"
import script from "./InvoiceEmail.vue?vue&type=script&lang=js"
export * from "./InvoiceEmail.vue?vue&type=script&lang=js"

import "./InvoiceEmail.vue?vue&type=style&index=0&id=5f929636&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__